import { createPortal } from 'react-dom';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import SignIn from './SignInFlow/SignIn';
import SignUp from './SignUpFlow/SignUp';
import { WindowSizeContext } from '../../App';
import './Auth.css';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';

const Auth = ({ onLogin, initialView, handleOutsideClick }) => {

  // Get the window size
  const { deviceType } = useContext(WindowSizeContext);
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState(initialView || 'signin');

  // Update URL when view changes
  useEffect(() => {
    const path = currentView === 'signin' ? '/sign-in' : '/sign-up';
    // Only navigate if we're not already on the correct path
    if (window.location.pathname !== path) {
      navigate(path, { replace: true });
    }

    const pageTitle = currentView === 'signin' ? 'Sign In' : 'Sign Up';
    document.title = `${pageTitle} - Quoll Dashboard`;
  }, [currentView, navigate]);

  const handleBack = () => {
    // Navigate to the external URL
    window.location.href = 'https://quollintelligence.com';
  };

  const handleViewToggle = (newView) => {
    setCurrentView(newView);
  };

  const popupRef = useRef(null);

  useEffect(() => {
    const handleClick = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleOutsideClick?.();
      }
    };

    if (handleOutsideClick) {
      document.addEventListener('mousedown', handleClick);
      return () => document.removeEventListener('mousedown', handleClick);
    }
  }, [handleOutsideClick]);

  // Add effect to handle body scroll
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const BenefitsList = () => {
    const benefits = [
      "100% Free (Seriously, it's Free)",
      "Save Properties and Project Plans",
      "Get Help From Area Experts",
      "Have Companies Compete For Your Business",
      "Schedule Free Calls With Quoll Experts",
    ];

    return (
      <div className="benefits-section">
        {/* <div className="benefits-image-container">
          <img
            src="https://d2dhzsfgxco53w.cloudfront.net/dashboard-marketing-image.png"
            alt="Dashboard Marketing Image"
            className="benefits-image"
          />
        </div> */}
        {/* <h2 className="benefits-title">Why Join?</h2> */}
        <div className="benefits-container">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-item">
              <span className="auth-benefits-checkmark">✓</span>
              <div className="benefit-text text-align-center">{benefit}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return createPortal(
    <div className="auth-frame-overlay">
      <div
        className="auth-frame-popup"
        ref={popupRef}
        onClick={e => e.stopPropagation()}
      >
        <div className={`auth-container auth-container-${deviceType} ${currentView === 'signup' ? 'signup-layout' : ''}`}>
          {currentView === 'signup' && deviceType !== 'mobile' && <BenefitsList />}
          <div className={`auth-main-content ${currentView === 'signup' && deviceType !== 'mobile' ? 'with-benefits' : ''}`}>
            {/* <div className={`auth-back-button auth-back-button-${deviceType}`} onClick={handleBack}>
          <span className="auth-arrow-left">&#8592;</span>
          <span>Back</span>
        </div> */}
            <div className={`auth-logo-header auth-logo-header-${deviceType}`}>
              <div className={`auth-logo-container auth-logo-container-${deviceType}`}>
                <img
                  src="https://d2dhzsfgxco53w.cloudfront.net/business-logo-just-icon.png"
                  alt="Business Logo"
                  className="auth-logo"
                  style={{ objectFit: 'contain', width: '100%', height: '100%' }}
                />
              </div>
              <h1 className={`auth-section-header auth-section-header-${deviceType}`}>{currentView === 'signin' ? 'Sign In' : 'Create Account'}</h1>
            </div>
            <div className={`auth-content auth-content-${deviceType}`}>
              {currentView === 'signin' ? (
                <SignIn onLogin={onLogin} />
              ) : (
                <SignUp onLogin={onLogin} setCurrentView={handleViewToggle} />
              )}
            </div>
            <div className={`toggle-view toggle-view-${deviceType}`}>
              <p>{currentView === 'signin' ? "Don't have an account?" : "Already have an account?"}</p>
              <button
                onClick={() => handleViewToggle(currentView === 'signin' ? 'signup' : 'signin')}
                className={`auth-toggle-button auth-toggle-button-${deviceType} box-shadow-standard`}
              >
                {currentView === 'signin' ? 'Create Account' : 'Sign In'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Auth;
